<template>
  <div class="settings-block">
    <div class="settings-block__title">
      <div class="settings-block__title-text">{{ t('Details') }}</div>
    </div>
    <div class="settings-block__content">
      <div class="align-center justify-center fill-height d-flex pa-3">
        <div class="details-item pl-10 pr-10 current-plan" md6 xs12>
          <div class="details-item_title">
            {{ t('Current Plan') }}
          </div>
          <div class="details-item_content">
            {{ store.billing.planName }} ${{
              numeral(store.billing.planPrice / 100).format('0,0[.]00')
            }}
          </div>
          <ui-button
            class="justify-center"
            :text="t('Change Plan')"
            icon="fas fa-exchange-alt"
            button-style="accent"
            @click="openChangePlan"
          />
        </div>
        <div class="details-item pl-10 pr-10 current-balance" md6 xs12>
          <div class="details-item_title">
            {{ t('Account Balance') }}
          </div>
          <div class="details-item_content">
            ${{ numeral(customerBalance / 100).format('0,0.00') }}
          </div>
          <ui-button
            class="justify-center"
            :text="t('Apply Promo')"
            icon="fas fa-gift"
            :button-style="openPromoDisabled ? 'default' : 'outline-accent'"
            @click="openPromo"
            :disabled="openPromoDisabled"
          />
        </div>
      </div>
      <div justify-start column fill-height class="mt-16">
        <div class="details-list">
          <div class="details-list_title">{{ t('Current plan') }}</div>
          <div class="details-list_text">{{ store.billing.planName }}</div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Monthly payment') }}</div>
          <div class="details-list_text">
            {{ numeral(store.billing.planMrr / 100).format('0,0.00') }}
          </div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Next Plan') }}</div>
          <div class="details-list_text">{{ store.billing.nextPlan.planName }}</div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Current Period') }}</div>
          <div class="details-list_text">
            {{ moment.unix(store.billing.subscriptionStart).format('DD MMMM YYYY') }} &mdash;
            {{ moment.unix(store.billing.subscriptionEnd).format('DD MMMM YYYY') }}
          </div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Events Included') }}</div>
          <div class="details-list_text">
            {{ numeral(store.billing.eventsIncluded).format('0,0') }}
          </div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Events Used') }}</div>
          <div class="details-list_text green--text">{{ store.billing.eventsUsed }}</div>
        </div>

        <div class="details-list">
          <div class="details-list_title">{{ t('Overage Events') }}</div>
          <div class="details-list_text">{{ store.billing.eventsOverage }}</div>
        </div>
        <div
          class="details-list"
          v-if="store.billing.planId !== 'basic' && store.billing.planId !== 'free'"
        >
          <div class="details-list_title">{{ t('Overage Cost') }}</div>
          <div class="align-end details-list_text">
            $ {{ numeral(store.billing.overageWorth).format('0,0.00[00]') }} (${{
              numeral(store.billing.overageCost).format('0,0.00[0]')
            }}
            {{ t('per 1000 events') }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import numeral from 'numeral';
import moment from 'moment-timezone';
import { useI18n } from '@/composables';
import { $emitter } from '@/services/emitter';
import { useStore } from '@/store';

const { t } = useI18n();
const store = useStore();

const openPromoDisabled = computed(() => (store.billingCustomer?.balance ?? 0) > 0);

const customerBalance = computed(() => store.billingCustomer?.balance);

const openPromo = () => {
  $emitter.emit('open-dialog', { name: 'PromoCode' });
};

const openChangePlan = () => {
  $emitter.emit('open-dialog', { name: 'ChangePlanDialog' });
};
</script>

<style lang="scss" scoped>
.details-item {
  text-align: center;
  width: 50%;
}
.details-item_title {
  font-size: 13px;
  font-weight: 600;
}

.details-item_content {
  color: var(--color-blue);
  font-size: 24px;
}

.details-list {
  height: 34px;
  border-bottom: 1px solid var(--color-gray10);
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:last-child {
    border-bottom: none;
  }
}
.details-list_title {
  font-size: 13px;
  font-weight: 600;
}

.details-list_text {
  font-size: 13px;
  text-align: end;
  align-items: flex-end;
}

.green--text {
  color: #4caf50 !important;
  caret-color: #4caf50 !important;
}
</style>

<style lang="scss">
.list-wrapper {
  border-bottom: 1px solid var(--color-gray10);

  &:last-child {
    border-bottom: none;
  }
}

.v-list__tile {
  padding: 0;
  height: 34px;
}
</style>
